import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useGetAmountSummaryFromFulfillment } from '../../../fulfillment-plans/amount-summary/use-get-amount-summary-from-fulfillment';
import CurrencyColumn from '../../../components/columns/currency-column';
import { messages } from '../messages';

const ShippingPaid = ({ fulfillmentId }) => {
  const amountSummary = useGetAmountSummaryFromFulfillment(fulfillmentId);
  if (!amountSummary?.shippingAmount) {
    return '';
  }
  const { value, code } = amountSummary.shippingAmount;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

ShippingPaid.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const shippingPaid = {
  getMessageDescriptor: () => messages.shippingPaid,
  name: <FormattedMessage {...messages.shippingPaid} />,
  id: 'shippingPaid',
  render: (data) => <ShippingPaid fulfillmentId={data.id} />,
};
